import React from 'react'
import "./Infobox.css"
import {Card,CardContent,Typography} from "@material-ui/core"

function Infobox({title,cases,total,active,...props}) {
  
    return (
       
            <Card className="infobox" onClick={props.onClick}>
                <CardContent>
                    <Typography color="textSecondary">
                        {title}
                    </Typography>
                    <h2 className="infobox__cases">{cases}</h2>
                    <Typography className="infobox__total" color="textSecondary">{total}</Typography>
                </CardContent>
            </Card>

    )
}

export default Infobox
